import React, { Component } from 'react';
import './Contact.css';
import contactInfo from './profile.json'
import profile from './mona_b.jpg';

class Contact extends Component {
  render() {
    return (
      <div className="Contact-info">
          <div>
            <h2>Contact</h2>
            <p>Name: {contactInfo.name}</p>
            <p>Location: {contactInfo.location}</p>
             <p className="social-icons">
                 <a href={contactInfo.twitter} target="_blank"><i className="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
                 <a href={contactInfo.github} target="_blank"><i className="fa fa-github fa-2x" aria-hidden="true"></i></a>
                 <a href={contactInfo.linkedin} target="_blank"><i className="fa fa-linkedin fa-2x" aria-hidden="true"></i></a>
             </p>
          </div>
          <div>
              <img src={profile} className="profile-img" alt="Mona Bärenfänger" />
          </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js